// A pick from a list (desktop click, phone sheet) only updates React state —
// no input/change event reaches the <form>, so FormActions' unsaved-changes
// guard never armed for picker-only edits. Pickers announce the edit instead.
export const FORM_DIRTY_EVENT = "vc:formdirty";

export function markFormDirty(el) {
    if (!el || typeof el.dispatchEvent !== "function") return;
    el.dispatchEvent(new CustomEvent(FORM_DIRTY_EVENT, { bubbles: true }));
}
